import { c as _c } from "react/compiler-runtime";
import { FontWeights } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { DEFAULT_TEXT_FONT_SIZE, DISABLED_OPACITY } from "@styles/common-styles";
/**
 * Renders a label that can be used inside dialogs.
 * The component take the full width of the parent and on the left side places a label.
 */
export function SphereLabel(t0) {
  const $ = _c(16);
  const {
    title,
    isRequired: t1,
    isDisabled: t2,
    rightSideComponent,
    sx
  } = t0;
  const isRequired = t1 === undefined ? false : t1;
  const isDisabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== sx) {
    t3 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: DEFAULT_TEXT_FONT_SIZE,
      fontWeight: FontWeights.ExtraBold,
      marginBottom: "4px",
      letterSpacing: "normal",
      ...sx
    };
    $[0] = sx;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = isDisabled ? DISABLED_OPACITY : 1;
  let t5;
  if ($[2] !== t4) {
    t5 = {
      opacity: t4,
      mr: "10px"
    };
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== title) {
    t6 = <Box component="span">{title}</Box>;
    $[4] = title;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isRequired) {
    t7 = isRequired && <Box component="span" sx={{
      color: "primary.main",
      padding: "3px"
    }}>*</Box>;
    $[6] = isRequired;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <Box component="div" sx={t5}>{t6}{t7}</Box>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== rightSideComponent || $[13] !== t3 || $[14] !== t8) {
    t9 = <Box component="div" sx={t3}>{t8}{rightSideComponent}</Box>;
    $[12] = rightSideComponent;
    $[13] = t3;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}